import { render, staticRenderFns } from "./area_base.vue?vue&type=template&id=0ec0c62c&"
import script from "./area_base.vue?vue&type=script&lang=js&"
export * from "./area_base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports